import React from 'react'
import { makeStyles, CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import CloseIcon from '@material-ui/icons/Close'
import { Person } from '@material-ui/icons'

import { isEmpty } from 'lodash'
import moment from 'moment'

import OccurrencesView from './OccurrencesView'
import SpecificTagView from './SpecificTagView'
import ReportCalendar from '../calendar/ReportCalendar'
import TabNavigation from '../../components/shared/TabNavigation'
import StyledSVG from '../../components/shared/StyledSVG'
import trangleWarningSVG from '../../assets/icons/triangle-warning-orange.svg'
import bathIcon from '../../assets/icons/report-bath-icon.svg'
import contentIcon from '../../assets/icons/report-content-icon.svg'
import cutleryIcon from '../../assets/icons/report-cutlery-icon.svg'
import diaryIcon from '../../assets/icons/report-diary-icon.svg'
import frequencyIcon from '../../assets/icons/report-frequency-icon.svg'
import messageIcon from '../../assets/icons/report-message-icon.svg'
import nurseIcon from '../../assets/icons/report-nurse-icon.svg'
import waterDropIcon from '../../assets/icons/report-water-icon.svg'
import warningIcon from '../../assets/icons/report-warning-icon.svg'
import sleepIcon from '../../assets/icons/report-sleep-icon.svg'
import snackIcon from '../../assets/icons/report-snack-icon.svg'
import taskIcon from '../../assets/icons/report-task-icon.svg'
import uniformIcon from '../../assets/icons/report-uniform-icon.svg'
import viewSVG from '../../assets/icons/pattern-view-icon.svg'
import ReportsInfos from '../../components/shared/ReportsInfos'
import CustomTable from '../../components/table/CustomTable'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    fontFamily: 'Montserrat, Source Sans Pro',
    overflow: 'hidden'
  },
  main_content_wrapper: {
    marginTop: 56,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, minmax(0, 1fr))'
  },
  first_row: {
    display: 'flex',
    flexDirection: 'column'
  },
  child_introdution: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  left_section: {
    gridColumn: 'span 3',
    height: '100%',
    [theme.breakpoints.down(1800)]: {
      gridColumn: 'span 4'
    }
  },
  right_section: {
    gridColumn: 'span 9',
    height: '100%',
    [theme.breakpoints.down(1800)]: {
      gridColumn: 'span 8'
    }
  },
  child_avatar: {
    borderRadius: 16,
    width: 80,
    height: 80
  },
  avatar_fallback_wrapper: {
    backgroundColor: '#F5F6F7',
    '& svg': {
      height: 'fit-content',
      width: 'fit-content'
    }
  },
  child_name_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  child_name: {
    display: 'flex',
    flexDirection: 'column',
    '& .classroom_names': {
      color: '#868E96',
      fontSize: 14,
      fontWeight: 500,
      margin: 0,
      textTransform: 'capitalize'
    },
    '& .name': {
      margin: 0,
      fontWeight: 500,
      fontSize: 32,
      lineHeight: '42px',
      color: '#386093'
    }
  },
  attendance_section: {
    display: 'flex',
    gap: 48,
    alignItems: 'center'
  },
  attendance_option: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .label': {
      margin: 0,
      fontWeight: 600,
      fontSize: 14
    },
    '& div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 56,
      width: 45,
      height: 33,
      color: '#555555'
    },
    '& .presence': {
      backgroundColor: '#E9FAD9'
    },
    '& .absence': {
      backgroundColor: '#FFE2E6'
    },
    '& .occurrence': {
      backgroundColor: '#FFE9DD'
    }
  },
  child_parents: {
    display: 'flex',
    alignItems: 'center',
    gap: 48,
    marginTop: 16,
    marginBottom: 24,
    '& .label': {
      fontWeight: 400,
      fontSize: 12,
      margin: 0
    },
    '& .child_parent_names': {
      fontWeight: 600,
      margin: 0
    }
  },
  parent_introdution: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  report_data_label: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .label': {
      margin: 0,
      fontWeight: 400
    },
    '& .data': {
      margin: 0,
      fontWeight: 600
    }
  },
  horizontal_bar: {
    height: 1,
    borderBottom: '1px #ADB8CC solid',
    width: '90%'
  },
  calendar_label: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 16,
    maxWidth: 340,
    '& .title': {
      color: '#386093',
      fontWeight: 600,
      fontSize: 24,
      margin: 0
    },
    '& .description': {
      color: '#7B7B7B',
      fontWeight: 500,
      fontSize: 14,
      margin: 0
    }
  },
  calendar_wrapper: {
    marginTop: 12
  },
  key_class: {
    marginBottom: '12px !important ',
    fontSize: '24px !important',
    fontWeight: '500 !important'
  },
  warning_wrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 32
  },
  warning: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 32px',
    gap: 12,
    backgroundColor: '#FFE9DD',
    borderRadius: 24,
    width: '85%',
    '& h1': {
      margin: 0,
      color: '#7B7B7B',
      fontSize: 16,
      fontWeight: 600
    }
  },
  close_icon: {
    position: 'absolute',
    top: 10,
    right: 16,
    width: 16,
    height: 16,
    cursor: 'pointer'
  },
  table_root: {
    '& .MuiTableCell-root': {
      fontFamily: 'Montserrat, Source Sans Pro !important'
    }
  },
  styled_view_svg: {
    stroke: '#ADB8CC',
    cursor: 'pointer'
  },
  back_btn_wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 56
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    '& span': {
      textTransform: 'initial'
    },
    width: 140,
    height: 48,
    padding: '14px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize'
  }
}))

const ContentByTab = React.memo(function ContentByTab (props) {
  const {
    reportAnswers,
    currentTab,
    tagsDetails,
    getReportStudentsAnswers,
    cleanReportStudentAnswers,
    childId,
    classes,
    history
  } = props
  const sagasParams = { childId, option: currentTab }
  const [selectedTag, setSelectedTag] = React.useState(null)

  const tagIconSelect = tagName => {
    const tagsIcons = [
      { 'frequência/atraso': frequencyIcon },
      { uniforme: uniformIcon },
      { enfermaria: nurseIcon },
      { lição: diaryIcon },
      { recado: messageIcon },
      { conteúdo: contentIcon },
      { tarefa: taskIcon },
      { 'sono/dormiu/soneca': sleepIcon },
      { 'refeições/alimentação': cutleryIcon },
      { lanche: snackIcon },
      { 'higiene/evacuou/fisiológicas': bathIcon },
      { banho: waterDropIcon },
      { ocorrência: warningIcon }
    ]
    const tagNameDownCase = tagName.toLowerCase()
    const tagIcon = tagsIcons.find(item => {
      const objKey = Object.keys(item)[0]
      return objKey.split('/').some(key => tagNameDownCase.includes(key))
    })
    if (tagIcon) {
      return Object.values(tagIcon)[0]
    }
  }

  const handleViewReport = row => {
    const reportId = row.report_student.report_id
    const reportStudentId = row.report_student_id
    history.push(`/reports/${reportId}/classroom/${reportStudentId}`)
  }

  React.useEffect(
    () => {
      if (currentTab !== 'default') {
        getReportStudentsAnswers({
          onlyMainTags: true,
          childId,
          option: currentTab
        })
      }
      return () => {
        cleanReportStudentAnswers()
      }
    },
    [currentTab]
  )

  if (currentTab === 'default') {
    if (selectedTag) {
      return (
        <SpecificTagView
          tagIconSelect={tagIconSelect}
          getReportStudentsAnswers={getReportStudentsAnswers}
          childId={childId}
          selectedTag={selectedTag}
          setSelectedTag={setSelectedTag}
          cleanReportStudentAnswers={cleanReportStudentAnswers}
          reportAnswers={reportAnswers}
        />
      )
    } else {
      return (
        <ReportsInfos
          tagIconSelect={tagIconSelect}
          setSelectedTag={setSelectedTag}
          tags={tagsDetails}
        />
      )
    }
  } else if (currentTab === 'occurrence') {
    return <OccurrencesView occurrences={reportAnswers} />
  } else {
    return (
      <>
        <CustomTable
          from={'rooms'}
          rowColor={'#FFFFFF'}
          classRoot={classes.table_root}
          columns={[
            {
              key: 'title',
              name: 'Título',
              render: function render (row) {
                const reportTemplate = row.report_student.report.report_template
                return (
                  <div>
                    <p>{reportTemplate.title}</p>
                  </div>
                )
              }
            },
            {
              key: 'date',
              name: 'Data',
              render: function render (row) {
                const reportDate = row.report_student.report.created_at
                return (
                  <div>
                    <p>{moment(reportDate).format('DD/MM/YYYY')}</p>
                  </div>
                )
              }
            },
            {
              key: 'classroom',
              name: 'Turma',
              render: function render (row) {
                const classroom =
                  row.report_student.report.report_template.classroom?.[0]
                return (
                  <div>
                    <p>{classroom.name}</p>
                  </div>
                )
              }
            },
            {
              key: 'teacher',
              name: 'Professor',
              render: function render (row) {
                const teacher = row.user
                return (
                  <div>
                    <p>{teacher?.name}</p>
                  </div>
                )
              }
            },
            {
              key: 'actions',
              name: 'Ações',
              render: function render (row) {
                return (
                  <div
                    onClick={() => handleViewReport(row)}
                    className={classes.styled_view_svg}
                  >
                    <StyledSVG src={viewSVG} width={40} height={40} />
                  </div>
                )
              }
            }
          ]}
          data={reportAnswers.items}
          border={'none'}
          bodyBorder={'none'}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
          isFetching={reportAnswers.isFetching}
          fetchItems={getReportStudentsAnswers}
          sagasParams={sagasParams}
          pagination={reportAnswers.pagination}
        />
      </>
    )
  }
})

const ReportStudentDetailView = ({
  childId,
  match,
  getClassroomChildren,
  tagsCounterByChildRSPA,
  getStudentAnswersMetaRSPA,
  getReportStudentsAnswers,
  cleanReportStudents,
  cleanReportStudentAnswers,
  currentChild,
  reportAnswers,
  getReportStudents,
  reportStudentsPerDate
}) => {
  const classes = useStyles()
  const history = useHistory()
  const [tagsDetails, setTagsDetails] = React.useState([])
  const [warningViewed, setWarningViewed] = React.useState(false)
  const [currentTab, setCurrentTab] = React.useState('default')
  const [reportsGeneralInfos, setReportsGeneralInfos] = React.useState({})
  const currentYear = new Date().getFullYear()
  const tabOptions = [
    { id: 0, key: 'default', title: 'Geral' },
    { id: 1, key: 'presence', title: 'Presença' },
    { id: 2, key: 'absence', title: 'Faltas' },
    { id: 3, key: 'occurrence', title: 'Ocorrências' }
  ]

  React.useEffect(
    async () => {
      if (childId) {
        const tagsMetaData = await getStudentAnswersMetaRSPA({ childId }).then(
          res => {
            const data = res.reduce((acc, value) => {
              const key = Object.keys(value)?.[0]
              const extractedValue = Object.values(value)?.[0]
              acc[key] = extractedValue
              return acc
            }, {})
            return data
          }
        )
        getClassroomChildren(childId)
        tagsCounterByChildRSPA({ childId }).then(res => {
          setReportsGeneralInfos(prev => ({
            ...tagsMetaData,
            reports_viewed_count: res.reports_viewed_count,
            total_report_students: res.total_report_students
          }))
          setTagsDetails(
            Object.entries(res).map(item => ({ [item[0]]: item[1] }))
          )
        })
      }
    },
    [childId]
  )

  const AvatarComponent = () =>
    React.useMemo(
      () => {
        if (currentChild?.avatar_url) {
          return (
            <img
              className={classes.child_avatar}
              src={currentChild.avatar_url}
            />
          )
        } else {
          return (
            <div
              className={`${classes.child_avatar} ${
                classes.avatar_fallback_wrapper
              }`}
            >
              <Person />
            </div>
          )
        }
      },
      [currentChild?.avatar_url]
    )

  if (isEmpty(currentChild)) return <CircularProgress />
  return (
    <div className={classes.root}>
      <div className={classes.first_row}>
        <div className={classes.child_introdution}>
          <div className={classes.child_name_wrapper}>
            <AvatarComponent />
            <div className={classes.child_name}>
              <h1 className='name'>{currentChild?.name}</h1>
              <p className='classroom_names'>
                {currentChild?.classrooms
                  .filter(cc => +cc.year === +currentYear)
                  .map(cc => cc?.name)
                  .join(', ')}
              </p>
            </div>
          </div>
          <div className={classes.attendance_section}>
            {tabOptions.filter(item => item.id !== 0).map((item, idx) => {
              return (
                <div key={idx} className={classes.attendance_option}>
                  <p className='label'>{`${item.title}:`}</p>
                  <div className={item.key}>
                    {reportsGeneralInfos?.[item.key]?.total_count}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={classes.child_parents}>
          <div className={classes.parent_introdution}>
            <p className='label'>Responsável:</p>
            <p className='child_parent_names'>
              {currentChild.child_parents.length > 0
                ? currentChild.child_parents
                    .map(cp => cp.parent.name)
                    .join(' / ')
                : 'Não definido'}
            </p>
          </div>
          <div className={classes.report_data_label}>
            <p className='label'>Diários recebidos:</p>
            <p className='data'>{reportsGeneralInfos.total_report_students}</p>
          </div>
          <div className={classes.report_data_label}>
            <p className='label'>Diários lidos:</p>
            <p className='data'>{reportsGeneralInfos.reports_viewed_count}</p>
          </div>
        </div>
      </div>
      <div className={classes.main_content_wrapper}>
        <div className={classes.left_section}>
          <div className={classes.calendar_section}>
            <div className={classes.calendar_label}>
              <h1 className='title'>Ver diário por data</h1>
              <p className='description'>
                Escolha uma data no calendário abaixo para visualizar todos os
                detalhes do diário do aluno
              </p>
            </div>
            <div className={classes.calendar_wrapper}>
              <ReportCalendar
                cleanReportStudents={cleanReportStudents}
                reportStudents={reportStudentsPerDate}
                getReportStudents={getReportStudents}
                childId={childId}
              />
            </div>
          </div>
        </div>
        <div className={classes.right_section}>
          <TabNavigation
            keyClass={classes.key_class}
            options={tabOptions
              .filter(item => item.key !== 'presence')
              .map(item => ({
                key: item.title,
                handleChange: () => setCurrentTab(item.key)
              }))}
          />

          {!warningViewed && (
            <div className={classes.warning_wrapper}>
              <div className={classes.warning}>
                <StyledSVG src={trangleWarningSVG} width={30} height={30} />
                <p>
                  Os dados a seguir refletem apenas registros feitos no diário.
                  Podem não representar todas as presenças.
                </p>
                <CloseIcon
                  className={classes.close_icon}
                  onClick={() => setWarningViewed(true)}
                />
              </div>
            </div>
          )}
          <ContentByTab
            history={history}
            classes={classes}
            reportAnswers={reportAnswers}
            childId={childId}
            getReportStudentsAnswers={getReportStudentsAnswers}
            cleanReportStudentAnswers={cleanReportStudentAnswers}
            currentTab={currentTab}
            tagsDetails={tagsDetails}
          />
        </div>
      </div>
    </div>
  )
}

export default ReportStudentDetailView
